module.exports = __webpack_public_path__ + "DINNextLTPro-BoldCondensed.woff?4a63c5f4ba44bdf8b759e2eca57d9b4d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-BoldCondensed.woff
// module id = 1389
// module chunks = 0